// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__cjTa1","left":"StickyBox_left__TCcLw","right":"StickyBox_right__GNtL4"};